export const DEFAULT_TEMPLATE = `# Heading 1
* Sample bullet points
  * Nested bullet point
    * Nested bullet point

**Bold text**

*Italicized text*

## Heading 2
1. First item
2. Second item

## Heading 3

\`\`\`
def hello_world():
  print("Hello World!")
\`\`\`

[Link to docs](https://docs.merge.dev)
`;
